import {
  ai_repository,
} from '@/repositories';

import {
  AI_BUSINESS_CASES,
} from '@/constants';

const {
  ANALYZE_ACCOUNT,
  ANALYZE_CONTACT,
  ENGAGE_CONTACT,
  GENERATE_EMAIL_SUBJECT,
  GENERATE_VALUE_PROPOSITION,
} = AI_BUSINESS_CASES;

const actions = {
  /**
   * Generate user's value proposition based on the provided website URL for scraping
   * @param {*} _
   * @param {object} variables
   * @param {string} variables.scrape_url
   * @param {object} options
   * @returns {Promise<object>} - The generated value proposition
   */
  async generateValueProposition(_, input) {
    const {
      variables = {},
      options = {},
    } = input;

    return await ai_repository.askBusinessCase(GENERATE_VALUE_PROPOSITION, variables, options);
  },

  // Add other business cases here as needed

  /**
   * Read an AI response stream and write the text to the provided function
   * @param {*} _ - This store context (unused)
   * @param {object} input - input
   * @param {Response} input.response - Fetch response from AI service
   * @param {Function} input.writeText - A callback function to write the text to
   * @returns {Promise<object>} - Promise that resolves with the final output when the stream is done reading
   * @throws {Error} - Error if parameters are invalid or the stream is not read correctly
   */
  async readResponseStream(_, { response, writeText }) {
    if (!response || !response.body || typeof writeText !== 'function') {
      console.error('Invalid parameters for readResponseStream', {
        response,
        writeText,
      });
      throw new Error('Invalid parameters for readResponseStream');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    let buffer = '';
    let keep_reading = true;
    const output = {
      chat_id: null,
      content: '',
    };

    const readLine = (line) => {
      const parsed = JSON.parse(line);

      output.content += parsed.content || '';
      writeText(parsed.content || '');

      if (parsed.all_done) {
        output.chat_id = parsed.chat_id;
        keep_reading = false;
      }
    };

    try {
      while (keep_reading) {
        const { done, value } = await reader.read();

        if (done) { break; }

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');

        buffer = lines.pop();

        lines.forEach(readLine);
      }
    } catch (error) {
      console.error('Error reading response stream', error);
      throw error;
    } finally {
      reader.releaseLock();
    }

    return output;
  },

  /**
   * @param {*} _
   * @param {object} input
   * @param {object} input.variables
   * @param {object} input.options
   * @returns {Promise<object>} - The generated value proposition
   */
  async analyzeContact(_, input) {
    const {
      variables = {},
      options = {},
    } = input;

    return await ai_repository.askBusinessCase(ANALYZE_CONTACT, variables, options);
  },

  /**
   * @param {*} _
   * @param {object} input
   * @param {object} input.variables
   * @param {object} input.options
   * @returns {Promise<object>} - The generated value proposition
   */
  async analyzeAccount(_, input) {
    const {
      variables = {},
      options = {},
    } = input;

    return await ai_repository.askBusinessCase(ANALYZE_ACCOUNT, variables, options);
  },

  async engageContact(_, input) {
    const {
      variables = {},
      options = {},
    } = input;

    return await ai_repository.askBusinessCase(ENGAGE_CONTACT, variables, options);
  },

  async generateEmailSubject(_, input) {
    const {
      variables = {},
      options = {},
    } = input;

    return await ai_repository.askBusinessCase(GENERATE_EMAIL_SUBJECT, variables, options);
  },
};

export default {
  actions,
  namespaced: true,
};
